import { Injectable } from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse
} from '@angular/common/http';
import { AlertService } from './alert.service';
import { Observable, throwError, map, catchError } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

    mobileApp: any = environment.app
    private isSeenOnborading: any
    private introSlidesSeen: any;
    constructor(
        private alertService: AlertService,
        private router: Router,
        private authService: AuthService
    ) { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        let tokenReq: any;
        const userToken = (typeof window !== 'undefined') ? JSON.parse(window.localStorage.getItem(environment.tokenKey)) : null;
        let _clientToken = this.authService.getClientToken() || "";
        let _rmHeader: any = {};
        if (typeof window !== 'undefined') {
            if (window.sessionStorage.getItem('rmf')) {
                const _rmfData = JSON.parse(window.sessionStorage.getItem('rmf'));
                _rmHeader = {
                    'client-token': _rmfData.clientToken,
                    'rm-id': _rmfData.rmId,
                    'client-id': _rmfData.clientId,
                    'link-id': _rmfData.linkId,
                    'journey-type': _rmfData.journeyType
                }
            }
        }
        if (userToken && userToken.access_token) {
            if (new Date(+userToken.expires_in) < new Date()) {
                this.alertService.error({ title: 'Your session has expired. Please login to continue.' }, true);
                if (typeof window !== 'undefined') {
                    window.localStorage.removeItem(environment.tokenKey);
                    if (window.localStorage.getItem('isSeenOnboarding')) {
                        this.isSeenOnborading = JSON.parse(window.localStorage.getItem('isSeenOnboarding'))
                    }

                    if (window.localStorage.getItem('introSlides')) {
                        this.introSlidesSeen = JSON.parse(window.localStorage.getItem('introSlides'))
                    }
                    window.localStorage.clear();
                    if (this.isSeenOnborading) {
                        window.localStorage.setItem('isSeenOnboarding', 'true')
                    }

                    if (this.introSlidesSeen) {
                        window.localStorage.setItem('introSlides', this.introSlidesSeen)
                    }
                }
                this.authService.checkAuth(false, false)
                this.router.navigate(["/"]);
                return;
            } else {
                tokenReq = req.clone({
                    setHeaders: {
                        Authorization: `Bearer ${userToken.access_token}`, 'Cache-Control': 'no-cache', 'client-token': _clientToken,
                        ..._rmHeader,// Pragma: 'no-cache',
                    }
                });
            }
        }
        else {
            tokenReq = req.clone({
                setHeaders: {
                    Authorization: `Basic cGlja3JpZ2h0LWlkOnBpY2tyaWdodC1zZWNyZXQ=`, 'Cache-Control': 'no-cache', 'client-token': _clientToken,
                    ..._rmHeader,// Pragma: 'no-cache',
                }
            });
        }

        return next.handle(tokenReq).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                this.showError(error);
                return throwError(error);
            })
        );
    }

    private showError(err: any) {
        if (typeof window == 'undefined') {
            return;
        };
      if (!err || !err.error) {
        console.error('SSR err object:', err);
        return;
      }
      let errorObj: any;
        if (err.status === 401) {
            errorObj = { title: 'Your session has expired. Probably you have logged in a different machine.' };
            this.alertService.error(errorObj, true);
            if (typeof window !== 'undefined') {
                window.localStorage.removeItem(environment.tokenKey);
                if (window.localStorage.getItem('isSeenOnboarding')) {
                    this.isSeenOnborading = JSON.parse(window.localStorage.getItem('isSeenOnboarding'))
                }

                if (window.localStorage.getItem('introSlides')) {
                    this.introSlidesSeen = JSON.parse(window.localStorage.getItem('introSlides'))
                }
                window.localStorage.clear();
                window.sessionStorage.removeItem("investpackFilter");
                if (this.isSeenOnborading) {
                    window.localStorage.setItem('isSeenOnboarding', 'true')
                }

                if (this.introSlidesSeen) {
                    window.localStorage.setItem('introSlides', this.introSlidesSeen)
                }
            }
            this.authService.checkAuth(false, false)
            return;
        } else if (err.status === 504) {
            errorObj = { title: 'No internet connection. Please Try Again.' };
            this.alertService.error(errorObj, true);
            return;
        } else if (err.error && err.error.error && err.error.error.status === 403) {
            errorObj = { title: err.error.error.message };
            this.alertService.error(errorObj, true);
            this.router.navigate(['/products'])
            return;
        }
        if (err.error && (err.error.errorCode === 40010 || err.error.errorCode === 40000 || err.error.errorCode === 40011)) {
            return;
        }
        // return an observable with a user-facing error message
        let errString = '';
        if (err && err.error && err.error.message) {
            if (err.error.message.constructor === Array) {
                for (var i = 0; i < err.error.message.length; i++) {
                    if (i < err.error.message.length) {
                        errString += err.error.message[i].errorMessage + '\r\n';
                    }
                }
            } else if (err.error.message.constructor === Object) {
                errString = err.error.message.errorMessage;
            }
            else {
                errString = err.error.message;
            }
        }
        if (errString) {
            errorObj = { title: errString };
            this.alertService.error(errorObj, true);
        }
        return;
    }
}
